module.exports = __webpack_public_path__ + "img/cart.6db52d34.svg";